import * as S from "./loading.styles";

export default function Loading(props: any) {
  return (
    <S.Container
      className={`${props.type === "page" ? "page-load-wrap" : ""}`}
      color={props.color}
    >
      <div className="loader loader-1"></div>
      <div className="loading-txt">{props.text}</div>
    </S.Container>
  );
}
